import { render, staticRenderFns } from "./indexSouthernEn.vue?vue&type=template&id=74375980&scoped=true"
import script from "./indexSouthernEn.vue?vue&type=script&lang=js"
export * from "./indexSouthernEn.vue?vue&type=script&lang=js"
import style0 from "./indexSouthernEn.vue?vue&type=style&index=0&id=74375980&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74375980",
  null
  
)

export default component.exports